<div class="modal-header">
  <h4 id="country-selection-modal" class="modal-title">
    {{ "Select a country" | translate }}
  </h4>
  <button (click)="modal.dismiss()" class="close" aria-describedby="modal-title" type="button">
    <span aria-hidden="true">&times;</span>
  </button>
</div>

<div class="modal-body">
  <form [formGroup]="form">
    <formly-form [fields]="fields" [form]="form"></formly-form>
  </form>
</div>

<div class="modal-footer">
  <button
    [class.loading]="loadingService.loading$ | async"
    (click)="modal.dismiss()"
    class="btn btn-outline-secondary"
    type="button"
  >
    {{ "Cancel" | translate }}
  </button>

  <button
    [class.loading]="loadingService.loading$ | async"
    [disabled]="!form.valid"
    (click)="modal.close(form.get('country').value)"
    class="btn btn-primary"
    type="button"
  >
    {{ "Confirm" | translate }}
  </button>
</div>
